import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCalendarAlt,
    faHistory,
    faCalendarCheck,
} from "@fortawesome/pro-solid-svg-icons";

export const Toolkit = () => {
    const [toggleTranscript, setToggleTranscript] = useState(true);
    const [togglePastInfo, setTogglePastInfo] = useState(true);
    const [toggleAssignedInfo, setAssignedInfo] = useState(true);
    const [activeTool, setActiveTool] = useState(false);

    const handleTranscript = () => {
        document.body.classList.remove("showAssignedInfo", "showPastInfo");
        setToggleTranscript(!toggleTranscript);
        document.body.classList.toggle("showTranscriptInfo");
        setActiveTool(activeTool !== "transcript" ? "transcript" : false);
    };

    const handleTogglePastInfo = () => {
        document.body.classList.remove(
            "showAssignedInfo",
            "showTranscriptInfo"
        );
        setTogglePastInfo(!togglePastInfo);
        document.body.classList.toggle("showPastInfo");
        setActiveTool(activeTool !== "pastinfo" ? "pastinfo" : false);
    };

    const handleAssignedInfo = () => {
        document.body.classList.remove("showPastInfo", "showTranscriptInfo");
        setAssignedInfo(!toggleAssignedInfo);
        document.body.classList.toggle("showAssignedInfo");
        setActiveTool(activeTool !== "assignedinfo" ? "assignedinfo" : false);
    };

    return (
        <div className="toolkit">
            <button
                onClick={handleTranscript}
                className={`toolkit-btn ${
                    activeTool === "transcript" ? "activePopup" : ""
                }`}
            >
                <FontAwesomeIcon icon={faCalendarAlt} />
            </button>
            <button
                onClick={handleTogglePastInfo}
                className={`toolkit-btn ${
                    activeTool === "pastinfo" ? "activePopup" : ""
                }`}
            >
                <FontAwesomeIcon icon={faHistory} />
            </button>
            <button
                onClick={handleAssignedInfo}
                className={`toolkit-btn ${
                    activeTool === "assignedinfo" ? "activePopup" : ""
                }`}
            >
                <FontAwesomeIcon icon={faCalendarCheck} />
            </button>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/frontend/components/LearnerHome/Toolkit.js